import React, { useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { useAnimation, motion } from "framer-motion"
import { useInView } from "react-intersection-observer"
import { Link } from "gatsby"

const motionSection = {
  initial: { 
    opacity: 0, 
    // y: 20 
  },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 1,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.16, 1, 0.3, 1],
      // when: "beforeChildren",
    } 
  },
}
const imgOverlay = {
  initial: { right: 0 },
  animate: {
    right: "100%",
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 0.6,
    },
  },
  closed: {
    y: 0,
    opacity: 0,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 0.6,
    },
  },
}
const heroImg = {
  initial: { scale: 1.1 },
  animate: {
    scale: 1,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 2,
    },
  },
  closed: {
    y: 0,
    opacity: 0,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 2,
    },
  },
}
const motionText = {
  initial: { y: 20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.16, 1, 0.3, 1],
      duration: 1.5,
    },
  },
}

const hero = ({ block, raw, index }) => {
  const { flush, contained, height, heading, text, image, label, ctaLabel, ctaLink } = block
  const controls = useAnimation()
  const [ref, inView] = useInView({
    threshold: 0.4
  })

  // const [renderHeight, setRenderHeight] = useState("h-[70vh]") 
  let renderHeight = "h-[70vh]"

  if (height == "100vh") {
    renderHeight = "h-screen"
  }
  if (height == "70vh") {
    renderHeight = "h-[70vh]"
  }
  if (height == "50vh") {
    renderHeight = "h-[50vh]"
  }
  if (height == "550px") {
    renderHeight = "h-[550px]"
  }
  if (height == "450px") {
    renderHeight = "h-[450px]"
  }
  if (height == "300px") {
    renderHeight = "h-[300px]"
  }

  useEffect(() => {
    if (inView) {
      controls.start("animate")
    }
  }, [controls, inView])

  return (
    <motion.section
      className={ (flush? "" : "section ") + "module-hero page-header"}
      ref={ref}
      animate={controls}
      initial="initial"
      variants={motionSection}
    >
      <div className={(contained ? "container max-w-screen-xl relative" : "section--px relative")}>
        <div className={"module-hero__img relative overflow-hidden rounded-lg z-10 " + renderHeight}>
          {image && (
            <motion.div variants={heroImg} className="h-full w-full">
            <GatsbyImage
              image={image.asset.gatsbyImageData}
              alt={image.asset.altText}
              className="w-full h-full rounded-lg"
            />
          </motion.div>
          )}
          <div className="module-hero__img-overlay absolute inset-0 bg-black/30 z-10" />
        </div>
        <div className="module-hero__content max-w-[630px] z-10">
          <motion.span variants={motionText} className="mb-2">{label}</motion.span>
          <motion.h1 variants={motionText} className="h1 mb-2">{heading}</motion.h1>
          <motion.p variants={motionText}  className="mb-4">{text}</motion.p>
          {ctaLabel && (
            <motion.div  variants={motionText} >
              <Link to={ctaLink.slug.current} className="btn-primary">{ctaLabel}</Link>
            </motion.div>
          )}
          
        </div>
      </div>
     
    </motion.section>
  )
}

export default hero
